import { Box, Container, Stack, Typography, Unstable_Grid2 as Grid } from "@mui/material";
import { HorizontalScrollList } from "../../horizontal-scroll-list/index.js";
import { SingleProduct } from "../../product/index.js";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import React from "react";
export const ViewMobileCompact = ({ featuredParagraphs, featuredProductId, products, recommendedProductIds, showPrice = true, }) => {
    const { t } = useTranslation("c-common");
    const router = useRouter();
    const featuredProduct = products.find(({ id }) => featuredProductId === id) ?? products[0];
    const recommendedProducts = !!recommendedProductIds &&
        products.filter(({ id }) => recommendedProductIds.includes(id)).length === 2
        ? products.filter(({ id }) => recommendedProductIds.includes(id))
        : [products[1], products[2]];
    const initiallyHiddenProducts = products.filter(({ id }) => id !== featuredProduct.id && recommendedProducts.map(({ id }) => id).includes(id) === false);
    const scrollProducts = [...recommendedProducts, ...initiallyHiddenProducts];
    const PADDING = 2;
    const BORDER_RADIUS = "12px";
    const categoryPath = t("slug-print");
    return (React.createElement(Box, { sx: { pt: 4, pb: 6 } },
        React.createElement(Container, { maxWidth: "xl", sx: { pb: 5 } },
            React.createElement(Grid, { container: true, onClick: () => router.push(`/${categoryPath}/${featuredProduct.slug}`) },
                React.createElement(Grid, { xs: 5.75, sx: {
                        background: "white",
                        borderBottomLeftRadius: BORDER_RADIUS,
                        borderTopLeftRadius: BORDER_RADIUS,
                        p: PADDING,
                        zIndex: 10,
                    } },
                    React.createElement(SingleProduct, { hover: false, product: featuredProduct, showPrice: showPrice })),
                React.createElement(Grid, { xs: 6.25, sx: {
                        background: "white",
                        borderBottomRightRadius: BORDER_RADIUS,
                        borderTopRightRadius: BORDER_RADIUS,
                        hieght: "100%",
                        pl: 2,
                        pr: PADDING,
                        py: PADDING,
                    } },
                    React.createElement(Stack, { direction: "column", alignItems: "center", justifyContent: { xs: "flex-start", lg: "center", xl: "flex-start" }, sx: { height: "100%" } },
                        !!featuredParagraphs && (React.createElement(React.Fragment, null, featuredParagraphs.map((p, ix) => (React.createElement(Typography, { key: `featured-paragrapg-${ix}`, paragraph: true, sx: { textAlign: "center" }, variant: "body3" }, p))))),
                        !featuredParagraphs && (React.createElement(Typography, { component: "div", sx: { textAlign: "center" }, variant: "body3", dangerouslySetInnerHTML: { __html: featuredProduct.teaser } })))))),
        React.createElement(HorizontalScrollList, { items: 3.15 }, scrollProducts.map((product) => (React.createElement(Box, { component: "li", key: `view-mobile-compact-product-${product.slug}` },
            React.createElement(SingleProduct, { product: product, showPrice: showPrice })))))));
};
//# sourceMappingURL=view-mobile-compact.js.map